import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { reqToForgotPassword } from "../redux/authSlice";
// import { routes } from "../helpers/constants";
import { emailIcon, BackArrowIcon } from "../assets/icons";
// import Loader from "../components/Loader";
import LoginLeftBg from "../assets/images/login-left-bg.png";
import LoginRightTopBg from "../assets/images/login-right-top-bg.png";
import LoginRightBottomBg from "../assets/images/Right-bottom.png";
import signLogo from "../assets/images/signLogo.png";
import forgotPassword1 from "../assets/images/forgot-password1.png";
import { reqToForgotPassword } from "../redux/slices.js/authentication/authenticationSlice";
import { forgotPasswordSchema } from "../Validations/AuthValidation";
import Loader from "../components/Loader";
import { notify } from "../helpers/commonFunctions";
import { routes } from "../helpers/constants";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loader = useSelector((state) => state.authentication.loader);

  const initialValues = { email: "" };

  const handleSubmit = (values) => {
    const reqObj = { email: values?.email };
    dispatch(
      reqToForgotPassword({
        data: reqObj,
        onSuccess: (res) => {
          notify(res?.data?.message, "success");
          navigate(routes.verifyOtp);
          localStorage.setItem("forgotEmail", values.email);
        },
        onFailure: () => {},
      })
    );
  };

  return (
    <>
      {loader && <Loader />}
      <div className="signup-page bg-white">
        <div className="container">
          <div className="signup-container h-screen flex items-center flex-wrap relative">
            <div className="py-3 w-full lg:w-1/2 h-full hidden lg:flex">
              <div className="signup-left w-full h-full lg:flex items-start justify-between flex-col  bg-blue relative rounded-[30px]">
                <img
                  src={LoginLeftBg}
                  alt="LoginLeftBg"
                  className="absolute left-0 top-0 z-0"
                />
                <img
                  src={LoginRightTopBg}
                  alt="LoginRightTopBg"
                  className="absolute right-0 top-0 z-0"
                />
                <img
                  src={LoginRightBottomBg}
                  alt="LoginRightBottomBg"
                  className="absolute right-0 bottom-0 z-0"
                />
                <div className="signUpText flex flex-col gap-5 ps-[45px] pt-[35px]">
                  <img src={signLogo} className="max-w-[168px]" alt="" />
                </div>
                <img
                  src={forgotPassword1}
                  alt="signup"
                  className="mb-0 object-contain w-auto h-[70%] z-0"
                />
              </div>
            </div>

            <div
              className={`signup-right overflow-auto w-full lg:w-1/2 mx-auto md:px-[70px] h-full py-10 flex items-center justify-center flex-col px-4 relative`}
            >
              <div className="backArrow absolute md:left-[70px] top-10 left-4">
                <button
                  type="button"
                  aria-label="Go back"
                  onClick={() => navigate(-1)}
                  className="cursor-pointer"
                >
                  {BackArrowIcon}
                </button>
              </div>
              <div className="signup-right-title pb-[53px]">
                <div
                  className=" w-[84px] h-[84px]
    border-[16px] border-[#E3EAF9]
    rounded-full
    flex items-center justify-center
    mx-auto mb-[20px]"
                >
                  {emailIcon}
                </div>
                <h1 className="font-roboto mb-2 text-center text-black  inner-title">
                  Forgot Password?
                </h1>
                <p className="text-p mb-0 text-gray w-80 text-center">
                  Enter your email address, a 6 digit code will be sent, in
                  order to recover your password.
                </p>
              </div>

              <div className={` w-full lg:max-w-lg space-y-4 pb-5`}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={forgotPasswordSchema}
                  onSubmit={handleSubmit}
                >
                  {() => (
                    <Form className="w-full signin-form space-y-4 h-full flex flex-col">
                      <div className="flex-1">
                        <label>Email</label>
                        <div className="text-left">
                          <Field
                            name="email"
                            type="email"
                            placeholder="Enter Email"
                            className="w-full"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-red-500 text-sm mt-1"
                          />
                        </div>
                      </div>

                      <div className="pt-5">
                        <button type="submit" className="btn-yellow mx-auto">
                          Continue
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
